
import Vue from "vue";

export default Vue.extend({
	props: {
		to: String,
		link: String,
		color: String,
		backgroundColor: String,
		flat: Boolean,
		disabled: Boolean,
		round: Boolean,
		sm: Boolean,
		lg: Boolean,
		xl: Boolean,
		leftAlign: Boolean,
		rightAlign: Boolean,
		thin: Boolean,
		thinRight: Boolean,
		thinLeft: Boolean,
		icon: [String, Array as ()=>string[]],
	},
	computed: {
		computedTo(): string {
			return this.to || this.$route.fullPath;
		},
		textAlign():string {
			if (this.leftAlign) {
				return "left";
			}
			if (this.rightAlign) {
				return "right";
			}
			return "center";
		},
		tabindex():number{
			if (this.disabled){
				return -1;
			}
			return 0;
		}
	},
	methods: {
		onClick(event: Event) {
			if (this.disabled){
				return;
			}
			if (this.to){
				this.$router.push(this.to);
			}
			if (this.link){
				window.open(this.link);
				return;
			}
			event.preventDefault(); // Stops router navigation bugs
			this.$emit("click", event);
		},
		focus() {
			(this.$el as HTMLElement).focus();
		},
		onKeyDown(event:KeyboardEvent) {
			if (this.disabled){
				return;
			}
			this.$emit("keydown", event);
		},
		onKeyPress(event:KeyboardEvent) {
			if (this.disabled){
				return;
			}
			this.$emit("keypress", event);
		},
		onMouseDown(event:KeyboardEvent) {
			if (this.disabled){
				return;
			}
			this.$emit("mousedown", event);
		},
		onKeyUp(event:KeyboardEvent) {
			if (this.disabled){
				return;
			}
			this.$emit("keyup", event);
		}
	}
});
